import React from "react";

import "./PrintTemplate.css";
import PrintTemplateA5 from "./PrintTemplateA5";

interface Props{
    toningData:any;
}
export class PrintTemplateA5Printer extends React.PureComponent<Props> {
  render() {
    return (
      <PrintTemplateA5 toningData={this.props.toningData} />
    );
  }
}
